import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6282a0ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nerv-topbar" }
const _hoisted_2 = { class: "nerv-page-frame nerv-topbar-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "brand-mark" }, "DEV1", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "brand-sub nerv-caption" }, "Consulting", -1))
const _hoisted_5 = {
  class: "nerv-nav",
  "aria-label": "Primary"
}
const _hoisted_6 = { class: "readout" }
const _hoisted_7 = { class: "nerv-data-label" }
const _hoisted_8 = { class: "nerv-caption clock" }
const _hoisted_9 = ["aria-expanded"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "mobile-nav",
  "aria-label": "Primary mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "brand",
        "aria-label": "Dev1 Consulting home"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.to,
            to: item.to,
            class: _normalizeClass(["nerv-nav-link", { 'is-active': _ctx.isActive(item.to) }])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.code), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.clock), 1)
      ]),
      _createElementVNode("button", {
        class: "menu-toggle",
        type: "button",
        "aria-expanded": _ctx.open,
        "aria-label": "Toggle navigation",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
      }, _hoisted_13, 8, _hoisted_9)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              class: _normalizeClass(["nerv-nav-link", { 'is-active': _ctx.isActive(item.to) }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}